module.exports = __webpack_public_path__ + "static/media/8@1024w.6f833c0c.jpg";